/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_variants/dimensions/:dimension/eligible_base_creatives" endpoint.
 * Returns base creatives eligible for a given dimension based on the DSA's liquid support map.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreatives } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreatives =
  reactQueryFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreatives,
    (
      signal: AbortSignal,
      appGroupId: string,
      dsaId: string,
      dimension: string
    ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult> => {
      return fetch(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/creative_variants/dimensions/${dimension}/eligible_base_creatives`,
        "GET",
        {},
        { signal }
      );
    },
    isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionEligibleBaseCreativesResult
  );
